/** Messages between the admin editor (LivePreview) and the preview page (/form-preview). */
export const PREVIEW_MESSAGES = {
  ready: 'fm-form-preview:ready',
  data: 'fm-form-preview:data',
  focus: 'fm-form-preview:focus',
};

export const PREVIEW_PATH = '/form-preview';
